import { useState, useEffect } from "react";
import { getSelectedText, insertTextAtCursor, removeSelectedText } from "../utils/writingHelpers";

export const useWritingClipboard = (textAreaRef, value, setValue) => {
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const clearClipboard = () => {
      navigator.clipboard.writeText("").catch((error) => {
        console.error("Clipboard clear error:", error);
      });
    };

    const timer = setTimeout(() => {
      if (document.hasFocus()) {
        clearClipboard();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleCopy = () => {
    const textArea = textAreaRef.current;
    const selection = getSelectedText(textArea);

    if (selection) {
      navigator.clipboard.writeText(selection.text);
    } else {
      setAlertMessage("Select the text to copy.");
      setShowAlert(true);
    }
  };

  const handleCut = () => {
    const textArea = textAreaRef.current;
    const selection = getSelectedText(textArea);

    if (selection) {
      navigator.clipboard.writeText(selection.text);
      removeSelectedText(textArea, value, setValue);
    } else {
      setAlertMessage("Select the text to cut.");
      setShowAlert(true);
    }
  };

  const handlePaste = async () => {
    const text = await navigator.clipboard.readText();
    const textArea = textAreaRef.current;

    if (!text) {
      setAlertMessage("Nothing to paste.");
      setShowAlert(true);
    } else {
      insertTextAtCursor(textArea, text, value, setValue);
    }
  };

  return {
    alertMessage,
    showAlert,
    setShowAlert,
    handleCopy,
    handleCut,
    handlePaste
  };
};
